import React from "react";
import { Redirect } from "expo-router";

function Page(): React.JSX.Element {
  return <Redirect href="/" />;
}

export default Page;
